import { useErrorNotification } from "@/react/notifications";
import JobsTable from "@/react/features/jobs/JobsTable";
import { useGetCustomerJobsByTypeQuery } from "@/react/features/jobs/jobsApi";

const JobsByTypePage = ({ type }) => {
  const {
    data,
    isFetching: isLoading,
    error,
    refetch,
  } = useGetCustomerJobsByTypeQuery({ type });

  useErrorNotification(error);

  return <JobsTable jobs={data} isLoading={isLoading} refetch={refetch} />;
};

export default JobsByTypePage;
